import { SettingsRepository } from "../repositories/SettingsRepository";
import { VerificationUploadResult } from "../entities/VerificationUploadResult";

export class SendVerificationPhotoConfig {
	constructor(private repository: SettingsRepository) {}

	execute(params: SendVerificationPhotoParams): Promise<VerificationUploadResult> {
		return this.repository.sendVerificationPhoto(params.file, params.code);
	}
}

export class SendVerificationPhotoParams {
	constructor(public file: File, public code: string) {}
}
